
/* PRESALE TAKEDOWN v4 (Sep 13 2026)

   Shopify blocks theme-file writes against the LIVE theme, so nothing can edit
   the homepage at the moment a presale closes. This hides a presale's homepage
   surfaces on a schedule instead, using the same Pacific-time rule the
   countdown itself uses. Publish any time BEFORE the close: everything stays
   visible until the deadline and disappears on its own after it.

   SELECTOR NOTE: a section's real DOM id is NOT "shopify-section-<key>".
   Shopify prefixes it with the template. Match the suffix, and keep the id^
   guard, because inner nodes share the same suffix.

   SLIDE NOTE: slides are matched on IMAGE FILENAME. That is a deliberate
   coupling and it is fragile in one specific way: renaming the banner file
   breaks the match silently, with no error. v4 exists because exactly that
   happened. The Bismuth banner used to be the generically named
   "objectshow-home-banner-desktop.png"; it is now
   "bismuth-plush-katyj98-banner-desktop.png". BOTH names are listed below, so
   this keeps working if an older theme is ever republished. IF YOU RENAME A
   BANNER, ADD THE NEW NAME HERE.

   TIMING NOTE, learned by breaking it: the slideshow is a <media-carousel>
   custom element that boots Swiper. Removing a slide while the page is still
   parsing stopped Swiper initialising at all, leaving a dead carousel with no
   pagination. So removal WAITS for the Swiper instance to exist, then takes the
   slide out and tells Swiper to recount. Autoplay is 5s per slide and the
   removed slide is not first, so there is ample margin.

   Slides are REMOVED, not CSS hidden: a hidden but present slide stays in the
   rotation and shows as a blank frame every loop.

   Test hook: ?presale_takedown_test=1 forces the post deadline state.
*/
(function () {
  var TAKEDOWNS = [
    {
      label: 'Bismuth',
      year: 2026, month: 9, day: 14, hour: 0, minute: 0,
      sections: [
        'section_countdown_timer_8eJJDV',
        'section_product_xfDpjz'
      ],
      slides: [
        'bismuth-plush-katyj98-banner-desktop',
        'bismuth-plush-katyj98-banner-mobile',
        'objectshow-home-banner-desktop',
        'objectshow-home-banner-mobile'
      ]
    }
  ];

  function pacificOffsetMinutes(utcDate) {
    var dtf = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      hour12: false,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    });
    var p = {};
    dtf.formatToParts(utcDate).forEach(function (x) { p[x.type] = x.value; });
    var hour = p.hour === '24' ? '00' : p.hour;
    var asUTC = Date.UTC(+p.year, +p.month - 1, +p.day, +hour, +p.minute, +p.second);
    return (asUTC - utcDate.getTime()) / 60000;
  }

  function pacificInstant(y, mo, d, h, mi) {
    var guess = Date.UTC(y, mo - 1, d, h, mi);
    var offset = pacificOffsetMinutes(new Date(guess));
    return guess - offset * 60000;
  }

  function selectorFor(key) {
    return '[id^="shopify-section-"][id$="__' + key + '"],#shopify-section-' + key;
  }

  function hideSections(keys) {
    var sel = keys.map(selectorFor).join(',');
    var style = document.createElement('style');
    style.setAttribute('data-presale-takedown', '');
    style.textContent = sel + '{display:none !important}';
    (document.head || document.documentElement).appendChild(style);
  }

  function slideMatches(slide, tokens) {
    var nodes = slide.querySelectorAll('img[src],img[srcset],source[srcset]');
    for (var i = 0; i < nodes.length; i++) {
      var v = (nodes[i].getAttribute('src') || '') + ' ' + (nodes[i].getAttribute('srcset') || '');
      for (var j = 0; j < tokens.length; j++) {
        if (v.indexOf(tokens[j]) !== -1) return true;
      }
    }
    return false;
  }

  function whenReady(el, cb, timeoutMs) {
    var start = Date.now();
    (function tick() {
      if (el.swiper) { cb(el.swiper); return; }
      if (Date.now() - start > timeoutMs) { cb(null); return; }
      setTimeout(tick, 100);
    })();
  }

  function sweep(tokens) {
    var containers = document.querySelectorAll('.swiper');
    for (var i = 0; i < containers.length; i++) {
      (function (c) {
        if (c.getAttribute('data-presale-swept')) return;
        var all = c.querySelectorAll('.swiper-slide');
        var hits = [];
        for (var k = 0; k < all.length; k++) {
          if (slideMatches(all[k], tokens)) hits.push(all[k]);
        }
        if (!hits.length) return;
        c.setAttribute('data-presale-swept', '1');
        whenReady(c, function (sw) {
          for (var m = 0; m < hits.length; m++) {
            if (hits[m].parentNode) hits[m].parentNode.removeChild(hits[m]);
          }
          if (sw) {
            try { sw.update(); } catch (e) {}
            try { if (sw.loopFix) sw.loopFix(); } catch (e) {}
            try { if (sw.pagination && sw.pagination.render) { sw.pagination.render(); sw.pagination.update(); } } catch (e) {}
            try { sw.slideTo(0, 0, false); } catch (e) {}
          }
          try { window.dispatchEvent(new Event('resize')); } catch (e) {}
        }, 10000);
      })(containers[i]);
    }
  }

  function scheduleSweep(tokens) {
    function run() { try { sweep(tokens); } catch (e) {} }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    window.addEventListener('load', run);
    setTimeout(run, 1200);
  }

  try {
    var forced = window.location.search.indexOf('presale_takedown_test=1') !== -1;
    var now = Date.now();
    var dueSections = [];
    var dueSlides = [];
    for (var i = 0; i < TAKEDOWNS.length; i++) {
      var t = TAKEDOWNS[i];
      if (forced || now >= pacificInstant(t.year, t.month, t.day, t.hour, t.minute)) {
        dueSections = dueSections.concat(t.sections || []);
        dueSlides = dueSlides.concat(t.slides || []);
      }
    }
    if (dueSections.length) hideSections(dueSections);
    if (dueSlides.length) scheduleSweep(dueSlides);
  } catch (e) {
    // A takedown that fails must never break the storefront.
  }
})();
